import { render, staticRenderFns } from "./module5.vue?vue&type=template&id=aa85defc&scoped=true"
import script from "./module5.vue?vue&type=script&lang=js"
export * from "./module5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa85defc",
  null
  
)

export default component.exports